export enum CertificateLanguage {
  GERMAN = 'de',
  ENGLISH = 'en',
}
